// auth.js - Get token dynamically from sessionStorage
export const getToken = () => {
  try {
    const studentSession = sessionStorage.getItem("studentSession");
    return studentSession ? JSON.parse(studentSession).token : null;
  } catch {
    return null;
  }
};

// Keep backward compatibility but deprecate usage
export const token = getToken();